import { Component } from '@angular/core';

@Component({
  selector: 'df-funnel-overview-content-funnel',
  templateUrl: './funnel-overview-content-funnel.component.html',
  styleUrls: ['./funnel-overview-content-funnel.component.scss'],
})
export class FunnelOverviewContentFunnelComponent {}
